import axios from 'axios';
import { showLoading, hideLoading, } from '../js/loading';
import router from '../router/index.js';
import {
  pageRouteName,
  requestUrl,
} from '../config/canNoCheckLoginInfo.js';
function noCheckResult({url}){
  return requestUrl.includes(url) || pageRouteName.includes(router.currentRoute.name)
}
function requestInterceptors(instance){
  instance.interceptors.request.use(req=>{
    console.log(req.url)
    const noCheckThisArr = noCheckResult({url: req.url})
    const cookie = document.cookie.split('; ').map(i=>i.split('=')).reduce((total, item)=>{
      total[item[0]] = item[1]
      return total
    },{})
    if(!cookie['userInfo'] && !sessionStorage.getItem('noUserInfo') &&　!noCheckThisArr) {
      sessionStorage.setItem('noUserInfo',1)
      alert('登录失效，请重新登录')
      location.href='/'
      return 
    }
    return req
  },err=>{
    return Promise.reject(err)
  })
}
function responseInterceptors(instance){
  instance.interceptors.response.use(req=>{
    const noCheckThisArr = noCheckResult({url: req.config.url})
    const cookie = document.cookie.split('; ').map(i=>i.split('=')).reduce((total, item)=>{
      total[item[0]] = item[1]
      return total
    },{})
    if(!cookie['userInfo'] && !sessionStorage.getItem('noUserInfo') && !noCheckThisArr) {
      sessionStorage.setItem('noUserInfo',1)
      alert('登录失效，请重新登录')
      location.href='/'
      return
    }
    return req
  },err=>{
    return Promise.reject(err)
  })
}
export function requestPostViaFormData(url='/',data,headers={ 'content-type': 'application/x-www-form-urlencoded' }){
  showLoading()
  let axiosObject = axios.create({headers,method:'post'});
  // requestInterceptors(axiosObject)
  responseInterceptors(axiosObject)
  const param = {
    url,
    data: toString.call(data)==='[object FormData]'?data:(()=>{
      if(toString.call(data)!=='[object Object]') return null
      return Object.entries(data).reduce((total,item)=>{
        total[item[0]] = item[1]
        return total
      },{})
    })(),
  };
  return axiosObject(param).finally(()=>hideLoading());
}
export default function requestData(url='/',method='GET',data,headers={ 'content-type': 'application/x-www-form-urlencoded' },obj,) {
  const { acceptNull=false, } = toString.call(obj)==='[object Object]'?obj:{}
  showLoading()
  let axiosObject = axios.create({headers,})
  // requestInterceptors(axiosObject)
  responseInterceptors(axiosObject)
  /*
    url method
    get 数据用params对象   post 用data对象
    设置请求头 ['Content-Type'] = 'application/x-www-form-urlencoded';
    */
  const param = {url,method,};
  if(param && Object.keys(param).length){
    if(!acceptNull && toString.call(data)==='[object Object]') data = Object.entries(data).filter(i=>![ '[object Null]', '[object Undefined]', ].includes(toString.call(i[1])) && String(i[1])).reduce((total,item)=>{
      total[item[0]] = item[1]
      return total
    },{})
    if(method==='POST' && toString.call(data)==='[object Object]') data = setFormData({keyValueObject:data});
    else if(method==='GET' && toString.call(data)==='[object Object]') data = setURLSearchParams({keyValueObject:data});
    param[method==='GET'?'params':'data']=data;
  }
  return axiosObject(param).finally(()=>hideLoading());
}
export const setURLSearchParams = ({keyValueObject}) => {
  const params = new URLSearchParams();
  Object.entries(keyValueObject).forEach(item=> params.append(item[0],String(item[1])) );
  return params;
}
export const setFormData = ({keyValueObject}) => {
  const formData = new FormData();
  Object.keys(keyValueObject).forEach(function (item) {
    formData.append(item, keyValueObject[item]);
  });
  return formData;
}
export const middleErrorInfo = 'Middle error ';
export const formatterData = ({status=0,dataArray=[],dataItem={},successMessage='',errorMessage=''}) =>{
  const returnData = {
    status,
  };
  if(dataArray.length) returnData['dataArray'] = dataArray;
  if(Object.entries(dataItem).length) returnData['dataItem'] = dataItem;
  if(successMessage) returnData['successMessage'] = successMessage;
  if(errorMessage) returnData['errorMessage'] = errorMessage;
  return returnData;
}
export const PHONE_REGULAR = /^1[3456789]\d{9}$/;
